module.exports = __webpack_public_path__ + "img/logement-etage-haut.1e94740a.png";